<template>
  <v-container>
    <v-col>
      <h2 v-if="hasManyId">EDITAR GRUPO DE EXAMEN</h2>
      <h2 v-else>CREAR NUEVO GRUPO DE EXAMEN</h2>
      <v-text-field v-model="examGroup.name" outlined label="Nombre"></v-text-field>
     <v-menu
        ref="beginsAtMenu"
        v-model="beginsAtMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="examGroup.begins_at"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            outlined
            v-model="examGroup.begins_at"
            label="Empieza a las"
            prepend-icon="mdi-clock-time-four-outline"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="beginsAtMenu"
          v-model="examGroup.begins_at"
          full-width
          @click:minute="$refs.beginsAtMenu.save(examGroup.begins_at)"
        ></v-time-picker>
      </v-menu>
      <v-menu
        ref="endsAtMenu"
        v-model="endsAtMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="examGroup.ends_at"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            outlined
            v-model="examGroup.ends_at"
            label="Termina a las"
            prepend-icon="mdi-clock-time-four-outline"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="endsAtMenu"
          v-model="examGroup.ends_at"
          full-width
          @click:minute="$refs.endsAtMenu.save(examGroup.ends_at)"
        ></v-time-picker>
      </v-menu>
      <v-autocomplete
        chips
        v-model="examGroup.degrees"
        :items="degrees"
        :loading="isLoadingDegree"
        :search-input.sync="searchDegree"
        outlined
        multiple
        color="white"
        hide-no-data
        item-text="name"
        item-value="id"
        label="Cinta"
        placeholder="Cinta"
      ></v-autocomplete>
      <v-btn v-if="!hideAddButton" primary @click="createNewExamGroup" class="blue ligthten-2">Agregar</v-btn>
    </v-col>
  </v-container>
</template>

<script>
var debounce = require('debounce');
export default {
  mounted() {
    this.$store.dispatch('Degree/index')
    if (this.hasManyId != 0) {
      this.$store.dispatch('ExamGroup/show', this.hasManyId).then(() => {
        this.examGroup = this.$store.getters['ExamGroup/examGroup']
      })
    }
  },
  computed: {
    degrees () {
      return this.$store.getters['Degree/degrees']
    },
  },
  props: {
    hideAddButton: {
      type: Boolean,
      default: false
    },
    triggerCreate: {
      type: Boolean,
      deafult: false
    },
    triggerEdit: {
      type: Boolean,
      deafult: false
    },
    parentId: {
      type: Number,
      default: 0
    },
    hasManyId: {
      type: Number,
      default: 0
    }
  },
  watch: {
    triggerCreate: function () {
      this.examGroup.exam_id = this.parentId
      this.$store.dispatch('ExamGroup/create', this.examGroup).then(() => {
        this.$emit('created', this.examGroup)
      })
    },
    triggerEdit: function () {
      console.log(this.triggerEdit)
      this.examGroup.exam_id = this.parentId
      this.$store.dispatch('ExamGroup/update', this.examGroup).then(() => {
        this.$emit('eddited', this.examGroup)
      })
    },
    searchDegree: debounce(function () {
      this.$store.dispatch('Degree/index', this.search ?`?name=${this.search}` : '')
    }, 500),
  },
  data () {
    return {
      isLoadingDegree: false,
      searchDegree: '',
      beginsAtMenu:'',
      endsAtMenu:'',
      triggerAddGroup: true,
      examGroup: {
        exam_id:'',
        name:'',
        begins_at:'',
        ends_at:'',
        degrees: []
      }
    }
  }
}
</script>

<style>

</style>